package com.exura.features.fileStorage.usecase

import com.exura.features.fileStorage.domain.repository.UserFileStorageRepository
import dev.gitlive.firebase.storage.File
import dev.gitlive.firebase.storage.StorageReference

class UploadFileUseCase(
    private val fileStorageRepository: UserFileStorageRepository,
) {
    suspend operator fun invoke(pathPrefix: String, filename: String, file: File): Result<StorageReference> =
        fileStorageRepository.uploadFile(pathPrefix, filename, file)
}
